import React from "react";
import classNames from "classnames";
import {Product, ProductMediaVariant} from "../../model/types";
import {ProductMediaSlider} from "./ProductMediaSlider";
import {Picture} from "@/shared/ui/Picture";
import {Link} from "@/shared/ui/Link";
import {getUrl} from "../../model/getUrl";
import {getTitle} from "../../model/getTitle";
import {getProductMedia} from "../../lib/getProductMedia";
import styles from "./ProductMedia.module.scss";

type Props = {
    product: Product;
    variant?: ProductMediaVariant;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
};

export const ProductMedia = ({product, variant = 'image', className, onClick}: Props) => {
    const title = getTitle(product);
    const media = getProductMedia(product);

    return (
        <Link
            href={getUrl(product)}
            title={title}
            onClick={onClick}
            className={classNames(styles.link, className)}
        >
            {variant === 'slider' ?
                <ProductMediaSlider media={media} alt={title} />
                :
                <Picture
                    src={product.img}
                    alt={title}
                    width={290}
                    height={290}
                    classes={{root: styles.picture}}
                />
            }
        </Link>
    );
}
